import * as React from 'react'

import type { RowType } from '../typings'
import { useData, useHandlers } from './hooks'
import type { ENTITY_TYPES } from '@sales-center/common'
import { AppointmentDialogWrapper } from '@user/components/Scheduling/Estimates/atoms'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

const noop = () => {}

type Props = {
  row?: RowType
  entityId: number
  onClose: () => void
  entityClosed: boolean
  entityType: ENTITY_TYPES
  anchorEl: HTMLElement | null
  canUpdate: boolean
}

export function AppointmentMenu(props: Props) {
  const {
    row,
    anchorEl,
    onClose,
    entityId,
    entityType,
    entityClosed,
    canUpdate,
  } = props

  const {
    open,
    orderUrl,
    canCancel,
    dialogOpen,
    linkToOrder,
    locationUrl,
    canComplete,
    activeDialog,
    canReschedule,
    setActiveDialog,
  } = useData({
    row,
    anchorEl,
    entityClosed,
  })

  const {
    onClickView,
    onCloseDialog,
    onCancelClick,
    onCompleteClick,
    onRescheduleClick,
  } = useHandlers({
    row,
    orderUrl,
    locationUrl,
    linkToOrder,
    setActiveDialog,
  })

  return (
    <>
      <Menu
        open={open}
        onClick={onClose}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={onClickView}>View Appointment In PestPac</MenuItem>
        {canUpdate && canReschedule && (
          <MenuItem onClick={onRescheduleClick}>
            Reschedule Appointment
          </MenuItem>
        )}
        {canUpdate && canComplete && (
          <MenuItem onClick={onCompleteClick}>Complete Appointment</MenuItem>
        )}
        {canUpdate && canCancel && (
          <MenuItem onClick={onCancelClick}>Cancel Appointment</MenuItem>
        )}
      </Menu>

      <AppointmentDialogWrapper
        open={dialogOpen}
        onCloseMain={noop}
        entityId={entityId}
        entityType={entityType}
        onClose={onCloseDialog}
        appointmentId={row?.appointmentId}
        completeView={activeDialog === 'complete'}
      />
    </>
  )
}
